export class WorkspaceNetworkingSettings {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "aws",
            "baseName": "aws",
            "type": "AwsNetworkingSettings",
            "format": ""
        },
        {
            "name": "gcp",
            "baseName": "gcp",
            "type": "GcpNetworkingSettings",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WorkspaceNetworkingSettings.attributeTypeMap;
    }
    constructor() {
    }
}
